

export const isString = (val) => {
    return typeof val === 'string' || val instanceof String;
}

/*
 * Use JSON.parse to convert unicode \\uXXXX; need to wrap in "" and
 * make sure the string itself doesn't contain any other quotes ".
 */
export const decodeUnicode = (val) => {
    try {
        val = val.replace(/"/g, '\\"');
        return JSON.parse('"' + val + '"');
    } catch (e) {
        return val;
    }
}
